// extracted by mini-css-extract-plugin
module.exports = {"Button":"src-components-Button-Button--3oAYw","primary":"src-components-Button-Button--393iB"};